import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { Result } from '../../../common-models/Result';

export class GetDanfeLabelPreGenerationInfoInput {
  orderIds: number[];
}

export class GetDanfeLabelPreGenerationInfoOutput {
  orderCountCannotPreGenerateLabelsByCarrierNoShippingLine: number;
  orderCountCannotPreGenerateLabelsByCarrierNoVirtualCollect: number;
  orderIdsPendingLabelPreGenerationByCarrier: number[];
  ordersWithLabelsPreGeneratedByCarrier: CarrierDanfeOrderLabelForPreGenerationInfo[];
  orderIdsNotGeneratingLabelsByCarrier: number[];
  message: string;
}

export class CarrierDanfeOrderLabelForPreGenerationInfo {
  orderId: number;
  label: string;
}

export class GetDanfeLabelPreGenerationInfoService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GetDanfeLabelPreGenerationInfoInput): Promise<Result<GetDanfeLabelPreGenerationInfoOutput> | null> => {
    const promise = this.http.post<Result<GetDanfeLabelPreGenerationInfoOutput>, GetDanfeLabelPreGenerationInfoInput>(`${this.baseUrlSislogApi}/v2/danfe-packing-label/pre-generation`, input);
    return promise;
  }
}